module.exports = __webpack_public_path__ + "img/digital-agency.b31db9c4.png";